import IconUiAccountCircleOutline from './account-circle-outline';
import IconUiAccountCircle from './account-circle';
import IconUiAccountPlus from './account-plus';
import IconUiAccount from './account';
import IconUiAirplaneTakeoff from './airplane-takeoff';
import IconUiAlertCircleOutline from './alert-circle-outline';
import IconUiAlertCircle from './alert-circle';
import IconUiAlertOutline from './alert-outline';
import IconUiAlert from './alert';
import IconUiAmplifier from './amplifier';
import IconUiArchive from './archive';
import IconUiArrowBottomLeft from './arrow-bottom-left';
import IconUiArrowBottomRight from './arrow-bottom-right';
import IconUiArrowCollapse from './arrow-collapse';
import IconUiArrowDownCircleOutline from './arrow-down-circle-outline';
import IconUiArrowDown from './arrow-down';
import IconUiArrowLeftCircleOutline from './arrow-left-circle-outline';
import IconUiArrowLeft from './arrow-left';
import IconUiArrowRightBold from './arrow-right-bold';
import IconUiArrowRightCircleOutline from './arrow-right-circle-outline';
import IconUiArrowRight from './arrow-right';
import IconUiArrowTopLeft from './arrow-top-left';
import IconUiArrowTopRight from './arrow-top-right';
import IconUiArrowUpCircleOutline from './arrow-up-circle-outline';
import IconUiArrowUp from './arrow-up';
import IconUiAutorenew from './autorenew';
import IconUiBellOutline from './bell-outline';
import IconUiBell from './bell';
import IconUiCalculator from './calculator';
import IconUiCalendarRefresh from './calendar-refresh';
import IconUiCalendar from './calendar';
import IconUiCancel from './cancel';
import IconUiCarKey from './car-key';
import IconUiCarSide from './car-side';
import IconUiCarTractionControl from './car-traction-control';
import IconUiCartOutline from './cart-outline';
import IconUiCart from './cart';
import IconUiCash from './cash';
import IconUiCellphone from './cellphone';
import IconUiChartLine from './chart-line';
import IconUiChat from './chat';
import IconUiCheckCircleOutline from './check-circle-outline';
import IconUiCheckCircle from './check-circle';
import IconUiCheck from './check';
import IconUiChevronDown from './chevron-down';
import IconUiChevronLeft from './chevron-left';
import IconUiChevronRight from './chevron-right';
import IconUiChevronUp from './chevron-up';
import IconUiCircleMedium from './circle-medium';
import IconUiClipboardArrowRightOutline from './clipboard-arrow-right-outline';
import IconUiClockFast from './clock-fast';
import IconUiClockOutline from './clock-outline';
import IconUiClock from './clock';
import IconUiCloseCircleOutline from './close-circle-outline';
import IconUiCloseCircle from './close-circle';
import IconUiClose from './close';
import IconUiCommentOutline from './comment-outline';
import IconUiComment from './comment';
import IconUiCompassOutline from './compass-outline';
import IconUiContentCopy from './content-copy';
import IconUiCreditCardOutline from './credit-card-outline';
import IconUiDeleteOutline from './delete-outline';
import IconUiDelete from './delete';
import IconUiDotsHorizontal from './dots-horizontal';
import IconUiDownload from './download';
import IconUiDrag from './drag';
import IconUiEmailOutline from './email-outline';
import IconUiEmail from './email';
import IconUiEmoticonOutline from './emoticon-outline';
import IconUiEmoticonSadOutline from './emoticon-sad-outline';
import IconUiExclamation from './exclamation';
import IconUiExport from './export';
import IconUiEyeOff from './eye-off';
import IconUiEyeOutline from './eye-outline';
import IconUiEye from './eye';
import IconUiFileDocumentBoxOutline from './file-document-box-outline';
import IconUiFileDocumentOutline from './file-document-outline';
import IconUiFileDownloadOutline from './file-download-outline';
import IconUiFileEye from './file-eye';
import IconUiFileMultiple from './file-multiple';
import IconUiFilePlus from './file-plus';
import IconUiFilterRemove from './filter-remove';
import IconUiFilter from './filter';
import IconUiFormatQuoteOpen from './format-quote-open';
import IconUiFridge from './fridge';
import IconUiGate from './gate';
import IconUiGiftOutline from './gift-outline';
import IconUiGift from './gift';
import IconUiHelpCircleOutline from './help-circle-outline';
import IconUiHelpCircle from './help-circle';
import IconUiHomeSearchOutline from './home-search-outline';
import IconUiHome from './home';
import IconUiInbox from './inbox';
import IconUiInformationCircleOutline from './information-circle-outline';
import IconUiInformationCircle from './information-circle';
import IconUiLeaf from './leaf';
import IconUiLink from './link';
import IconUiLockOutline from './lock-outline';
import IconUiLock from './lock';
import IconUiLogout from './logout';
import IconUiMagnify from './magnify';
import IconUiMapMarkerRadiusOutline from './map-marker-radius-outline';
import IconUiMapMarkerRadius from './map-marker-radius';
import IconUiMedicalBag from './medical-bag';
import IconUiMenuDown from './menu-down';
import IconUiMenu from './menu';
import IconUiMinusBoxOutline from './minus-box-outline';
import IconUiMinusCircleOutline from './minus-circle-outline';
import IconUiMinusCircle from './minus-circle';
import IconUiMinus from './minus';
import IconUiMoped from './moped';
import IconUiOpenInNew from './open-in-new';
import IconUiPaint from './paint';
import IconUiPartner from './partner';
import IconUiPartyPopper from './party-popper';
import IconUiPencilCircleOutline from './pencil-circle-outline';
import IconUiPencilCircle from './pencil-circle';
import IconUiPencil from './pencil';
import IconUiPercentOutline from './percent-outline';
import IconUiPhoneOutline from './phone-outline';
import IconUiPhone from './phone';
import IconUiPlusBoxOutline from './plus-box-outline';
import IconUiPlusCircleOutline from './plus-circle-outline';
import IconUiPlusCircle from './plus-circle';
import IconUiPlus from './plus';
import IconUiPrinter from './printer';
import IconUiRealEstate from './real-estate';
import IconUiRing from './ring';
import IconUiSailBoat from './sail-boat';
import IconUiSchool from './school';
import IconUiSettings from './settings';
import IconUiShovel from './shovel';
import IconUiSofa from './sofa';
import IconUiStarOutline from './star-outline';
import IconUiStar from './star';
import IconUiStethoscope from './stethoscope';
import IconUiSubdirectoryArrowRight from './subdirectory-arrow-right';
import IconUiSuitcase from './suitcase';
import IconUiTag from './tag';
import IconUiTelevision from './television';
import IconUiThumbUp from './thumb-up';
import IconUiTicketPercentOutline from './ticket-percent-outline';
import IconUiTicketPercent from './ticket-percent';
import IconUiTruck from './truck';
import IconUiTune from './tune';
import IconUiVanUtility from './van-utility';

export default {
  IconUiAccountCircleOutline,
  IconUiAccountCircle,
  IconUiAccountPlus,
  IconUiAccount,
  IconUiAirplaneTakeoff,
  IconUiAlertCircleOutline,
  IconUiAlertCircle,
  IconUiAlertOutline,
  IconUiAlert,
  IconUiAmplifier,
  IconUiArchive,
  IconUiArrowBottomLeft,
  IconUiArrowBottomRight,
  IconUiArrowCollapse,
  IconUiArrowDownCircleOutline,
  IconUiArrowDown,
  IconUiArrowLeftCircleOutline,
  IconUiArrowLeft,
  IconUiArrowRightBold,
  IconUiArrowRightCircleOutline,
  IconUiArrowRight,
  IconUiArrowTopLeft,
  IconUiArrowTopRight,
  IconUiArrowUpCircleOutline,
  IconUiArrowUp,
  IconUiAutorenew,
  IconUiBellOutline,
  IconUiBell,
  IconUiCalculator,
  IconUiCalendarRefresh,
  IconUiCalendar,
  IconUiCancel,
  IconUiCarKey,
  IconUiCarSide,
  IconUiCarTractionControl,
  IconUiCartOutline,
  IconUiCart,
  IconUiCash,
  IconUiCellphone,
  IconUiChartLine,
  IconUiChat,
  IconUiCheckCircleOutline,
  IconUiCheckCircle,
  IconUiCheck,
  IconUiChevronDown,
  IconUiChevronLeft,
  IconUiChevronRight,
  IconUiChevronUp,
  IconUiCircleMedium,
  IconUiClipboardArrowRightOutline,
  IconUiClockFast,
  IconUiClockOutline,
  IconUiClock,
  IconUiCloseCircleOutline,
  IconUiCloseCircle,
  IconUiClose,
  IconUiCommentOutline,
  IconUiComment,
  IconUiCompassOutline,
  IconUiContentCopy,
  IconUiCreditCardOutline,
  IconUiDeleteOutline,
  IconUiDelete,
  IconUiDotsHorizontal,
  IconUiDownload,
  IconUiDrag,
  IconUiEmailOutline,
  IconUiEmail,
  IconUiEmoticonOutline,
  IconUiEmoticonSadOutline,
  IconUiExclamation,
  IconUiExport,
  IconUiEyeOff,
  IconUiEyeOutline,
  IconUiEye,
  IconUiFileDocumentBoxOutline,
  IconUiFileDocumentOutline,
  IconUiFileDownloadOutline,
  IconUiFileEye,
  IconUiFileMultiple,
  IconUiFilePlus,
  IconUiFilterRemove,
  IconUiFilter,
  IconUiFormatQuoteOpen,
  IconUiFridge,
  IconUiGate,
  IconUiGiftOutline,
  IconUiGift,
  IconUiHelpCircleOutline,
  IconUiHelpCircle,
  IconUiHomeSearchOutline,
  IconUiHome,
  IconUiInbox,
  IconUiInformationCircleOutline,
  IconUiInformationCircle,
  IconUiLeaf,
  IconUiLink,
  IconUiLockOutline,
  IconUiLock,
  IconUiLogout,
  IconUiMagnify,
  IconUiMapMarkerRadiusOutline,
  IconUiMapMarkerRadius,
  IconUiMedicalBag,
  IconUiMenuDown,
  IconUiMenu,
  IconUiMinusBoxOutline,
  IconUiMinusCircleOutline,
  IconUiMinusCircle,
  IconUiMinus,
  IconUiMoped,
  IconUiOpenInNew,
  IconUiPaint,
  IconUiPartner,
  IconUiPartyPopper,
  IconUiPencilCircleOutline,
  IconUiPencilCircle,
  IconUiPencil,
  IconUiPercentOutline,
  IconUiPhoneOutline,
  IconUiPhone,
  IconUiPlusBoxOutline,
  IconUiPlusCircleOutline,
  IconUiPlusCircle,
  IconUiPlus,
  IconUiPrinter,
  IconUiRealEstate,
  IconUiRing,
  IconUiSailBoat,
  IconUiSchool,
  IconUiSettings,
  IconUiShovel,
  IconUiSofa,
  IconUiStarOutline,
  IconUiStar,
  IconUiStethoscope,
  IconUiSubdirectoryArrowRight,
  IconUiSuitcase,
  IconUiTag,
  IconUiTelevision,
  IconUiThumbUp,
  IconUiTicketPercentOutline,
  IconUiTicketPercent,
  IconUiTruck,
  IconUiTune,
  IconUiVanUtility,
};
